/* tslint:disable */
/* eslint-disable */
/**
 * Ameta hms API
 * A rest api for managing the ameta hms system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewDocument
 */
export interface NewDocument {
    /**
     * 
     * @type {string}
     * @memberof NewDocument
     */
    documentName: string;
    /**
     * 
     * @type {string}
     * @memberof NewDocument
     */
    docType: string;
}

export function NewDocumentFromJSON(json: any): NewDocument {
    return NewDocumentFromJSONTyped(json, false);
}

export function NewDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentName': json['documentName'],
        'docType': json['docType'],
    };
}

export function NewDocumentToJSON(value?: NewDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentName': value.documentName,
        'docType': value.docType,
    };
}


